import HttpClienteSeguroCore from '../../Servicios/HttpClienteSeguroCore';

/**
 * obtener listado de secciones habilitadas
 * @param {{portal:string, companyId:string }} objectRequest
 * @returns {Promise<{data:{sectionId:string, code:string, sectionOrder:number}[], status:number }>}
 */
export const seccionesHabilitadas = (objectRequest) => {
    return new Promise((resolve, reject) => {
        HttpClienteSeguroCore.post("/DatosSeccionPortal/SeccionesHabilitadas", objectRequest).then(response => {
            resolve(response);
        })
        .catch(error => {
            resolve(error.response);
        });
    });
};
